/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Groups_SubtitleInputs */

const en_my_groups_subtitle = /** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage and jump to your joined communities`)
};

const es_my_groups_subtitle = /** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona y salta a las comunidades a las que te has unido`)
};

const fr_my_groups_subtitle = /** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez et accédez aux communautés que vous avez rejointes`)
};

const de_my_groups_subtitle = /** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte und besuche deine beigetretenen Communities`)
};

const id_my_groups_subtitle = /** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola dan lompat ke komunitas yang Anda ikuti`)
};

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const ja_my_groups_subtitle = en_my_groups_subtitle;

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const zh_my_groups_subtitle = en_my_groups_subtitle;

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const ar_my_groups_subtitle = en_my_groups_subtitle;

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const it_my_groups_subtitle = en_my_groups_subtitle;

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const ru_my_groups_subtitle = en_my_groups_subtitle;

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const pt_my_groups_subtitle = en_my_groups_subtitle;

/** @type {(inputs: My_Groups_SubtitleInputs) => LocalizedString} */
const ko_my_groups_subtitle = en_my_groups_subtitle;

/**
* | output |
* | --- |
* | "Manage and jump to your joined communities" |
*
* @param {My_Groups_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const my_groups_subtitle = /** @type {((inputs?: My_Groups_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Groups_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_groups_subtitle(inputs)
	if (locale === "es") return es_my_groups_subtitle(inputs)
	if (locale === "fr") return fr_my_groups_subtitle(inputs)
	if (locale === "de") return de_my_groups_subtitle(inputs)
	if (locale === "ja") return ja_my_groups_subtitle(inputs)
	if (locale === "zh") return zh_my_groups_subtitle(inputs)
	if (locale === "ar") return ar_my_groups_subtitle(inputs)
	if (locale === "id") return id_my_groups_subtitle(inputs)
	if (locale === "it") return it_my_groups_subtitle(inputs)
	if (locale === "ru") return ru_my_groups_subtitle(inputs)
	if (locale === "pt") return pt_my_groups_subtitle(inputs)
	return ko_my_groups_subtitle(inputs)
});